// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/styles/components/common/DSANote.scss
// module id = 1305
// module chunks = 0